import {
  add,
  identity,
  inv,
  MathType,
  matrix,
  Matrix,
  multiply,
  subtract,
  transpose,
} from "mathjs";
import { ALL_MODELS, MODEL_STATES } from "../constants";
import { stateTypeF } from "../state";
import { BaseModel } from "./BaseModel";
import { dataSplit, infoType } from "./Dataset";
export type linearModelType = { coeff: Matrix; intercept: MathType };

export class RidgeRegression extends BaseModel {
  modelName = ALL_MODELS.ridgeReg;
  maxElements = 50000;
  lambdas = [
    Math.pow(10, 1),
    Math.pow(10, 0.5),
    Math.pow(10, 0),
    Math.pow(10, -0.5),
    Math.pow(10, -1),
    Math.pow(10, -1.5),
    Math.pow(10, -2),
    Math.pow(10, -2.5),
    Math.pow(10, -3),
  ];

  model: linearModelType;
  modelState = MODEL_STATES.ready;

  constructor(mlDataInfo: infoType) {
    super(mlDataInfo);
    this.initModel();
  }

  initModel() {}

  async train(
    trainData: dataSplit,
    state: stateTypeF,
    callbackFunction: Function
  ) {
    let matX = matrix(trainData.xTrain);
    let matY = matrix(trainData.yTrain);
    let bestModel: linearModelType;
    let count = 0;
    for (let lambda of this.lambdas) {
      let lambdaMat = multiply(
        lambda,
        identity(trainData.xTrain[0].length, trainData.xTrain[0].length)
      ) as Matrix;

      let coeff = multiply(
        multiply(
          inv(add(multiply(transpose(matX), matX), lambdaMat) as Matrix),
          transpose(matX)
        ),
        matY
      );

      let intercept = subtract(
        trainData.yTrain[0],
        multiply(trainData.xTrain[0], coeff)
      ); // Should be zero if data is normalized
      this.model = { coeff: coeff, intercept: intercept };
      if (this.isBestModel(trainData.xTest, trainData.yTest)) {
        bestModel = this.model;
      }
      count += 1;
      callbackFunction({
        trainState: "training",
        progress: count / this.lambdas.length,
      });
    }
    this.model = bestModel;
  }

  predict(X: number[][]) {
    let intercept = Array(X.length).fill(this.model.intercept) as number[];
    let output = add(multiply(X, this.model.coeff), intercept)[
      "_data"
    ] as number[];
    return output;
  }

  predictProbs(X: number[][]) {
    // Not implimented for this model
    return [] as number[][];
  }

  onBatchEnd(batch, logs, state) {}
}
